export default __webpack_public_path__ + "static/media/mission-main-bg.be730992.webp";